import { useAuthenticatedFetch } from './apiService';

export interface PromptTemplateType {
	id: number;
	title: string;
	description?: string;
	intro?: string;
	outro?: string;
	persona?: string;
	company?: string;
	scenario?: string;
	created_by?: string;
	create_date?: string;
	update_date?: string;
	update_by?: string;
}

export const usePromptTemplateService = () => {
	const authenticatedFetch = useAuthenticatedFetch();

	return {
		createPromptTemplate: async (
			data: Omit<PromptTemplateType, 'id' | 'created_by' | 'create_date' | 'update_date' | 'update_by'>
		): Promise<PromptTemplateType> => {
			const res = await authenticatedFetch('/prompt-templates/', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			});
			if (!res.ok) throw new Error('Failed to create prompt template');
			return await res.json();
		},

		fetchPromptTemplates: async (): Promise<PromptTemplateType[]> => {
			const res = await authenticatedFetch('/prompt-templates/');
			if (!res.ok) throw new Error('Failed to fetch prompt templates');
			return await res.json();
		},

		fetchPromptTemplate: async (id: number): Promise<PromptTemplateType> => {
			const res = await authenticatedFetch(`/prompt-templates/${id}`);
			if (!res.ok) throw new Error('Prompt template not found');
			return await res.json();
		},

		updatePromptTemplate: async (
			id: number,
			data: Partial<Omit<PromptTemplateType, 'id' | 'created_by' | 'create_date' | 'update_date' | 'update_by'>>
		): Promise<PromptTemplateType> => {
			const res = await authenticatedFetch(`/prompt-templates/${id}`, {
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			});
			if (!res.ok) throw new Error('Failed to update prompt template');
			return await res.json();
		},

		deletePromptTemplate: async (id: number): Promise<void> => {
			const res = await authenticatedFetch(`/prompt-templates/${id}`, {
				method: 'DELETE',
			});
			if (!res.ok) throw new Error('Failed to delete prompt template');
		},
	};
};

export default usePromptTemplateService;
